import { render, staticRenderFns } from "./DatosDeportivosCard.vue?vue&type=template&id=5451b6fc"
import script from "./DatosDeportivosCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosDeportivosCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports